export const ELEMENT_TYPE = '$w.AccountNavBar';
